import axios from 'axios';
import { FORGOT_PASSWORD_BACKOFFICE } from './constants';

const reject = error => {
  let eobj;
  if (error.response) {
    const { data } = error.response;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return Promise.reject(eobj);
};

export function forgotPassword(data) {
  return axios.post(FORGOT_PASSWORD_BACKOFFICE, data).catch(reject);
}
